import { UAParser } from 'ua-parser-js';

import { DEFAULT_USER_AGENT } from './device.constants';

interface IOSInfo {
  osName: string;
  osVersion: string;
}

export async function getOsInfo(userAgent: string = DEFAULT_USER_AGENT): Promise<IOSInfo> {
  const os = await new UAParser(userAgent).getOS().withClientHints();
  return {
    osName: os.name || '',
    osVersion: os.version || '-1',
  };
}
